var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded-/-All-/-Circle",
    fill: "#0079B9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    rx: 19
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-7",
    transform: "translate(20.000000, 19.000000) scale(-1, 1) translate(-20.000000, -19.000000) translate(9.000000, 11.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76441321,0 L7.76441321,2.78231832 L5.43507993,2.78231832 C4.14059178,2.78231832 3.62379037,4.31239304 3.42967926,4.86939099 L2.78305635,6.95646366 L2.58894524,6.95776934 C1.4885682,6.95776934 0.647834172,7.86172225 0.647834172,9.04484201 L0.647834172,10.436669 L0,10.4353634 L0,13.2176817 L2.58773399,13.2176817 C2.58773399,14.7477564 3.75240062,16 5.17546797,16 C6.59853532,16 7.76320196,14.7477564 7.76320196,13.2176817 L14.2331581,13.2176817 C14.2331581,14.7477564 15.3978247,16 16.8208921,16 C18.2439594,16 19.408626,14.7477564 19.408626,13.2176817 L21.99636,13.2176817 L22,0 L7.76441321,0 Z M4.3359452,5.21768168 C4.5300563,4.59155988 4.85398892,3.82585466 5.43632224,3.82585466 L7.76444427,3.82716033 L7.76444427,6.95776934 L3.81793253,6.95776934 L4.3359452,5.21768168 Z",
    id: "Fill-1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.6fac8e5de7a1fbea290c6cb850816335.svg";
export { ForwardRef as ReactComponent };